/** Search parameters used in the planogram page. */
export const searchParametersProduct = {
    CATEGORIES: 'categories',
    MANAGERS: 'managers',
    NAME: 'name',
    STATUS: 'status',
    SUPPLIERS: 'suppliers',
}

/** Search params used in the product API. */
export const searchParametersProductApi = {
    CATEGORIES: 'category__in',
    MANAGER: 'client__id',
    MANAGERS: 'client__in',
    NAME: 'name__icontains',
    STATUS: 'disabled',
    SUPPLIERS: 'supplier__in',
}
